import React from "react";
import "./AppleWalletBadge.css";
import { currentLanguage, t } from "../i18n";

// The "Add to Apple Wallet" button — one component for the QR page row and
// its full-screen Wallet step (WalletLastStep). The badge is Apple's own
// artwork in the page's language (public/apple-wallet/badge-<lang>.svg, from
// Apple's badge kit, founder 2026-10-09; the 1.5.1 app itself is English).
// Apple's rules: use their files as they are — never redraw, recolour, dim,
// animate or add effects (shadow, glow) — and keep a tenth of its height
// clear around it. So while the pass is being made it only stops taking
// taps; anything that moves around it is ours.
const AppleWalletBadge: React.FC<{ onClick: () => void; busy: boolean }> = ({ onClick, busy }) => (
  <button type="button" className="apple-wallet-badge" onClick={onClick} disabled={busy} aria-busy={busy} aria-label={t("dJQrPage.addToAppleWallet")}>
    <img src={`/apple-wallet/badge-${currentLanguage()}.svg`} alt="" />
  </button>
);

export default AppleWalletBadge;
